module.exports = __webpack_public_path__ + "087999560ed01e9393de106ec2ef99fb.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/icons/ic_temp.48.png
 ** module id = 665
 ** module chunks = 0
 **/